import createAPI from '@common/createAPI.js'
export default {
  // 角色管理
  postUserRoleSearch: config => createAPI('/api/role/search', 'post', config),
  postUserRoleDelete: config => createAPI('/api/role/delete', 'post', config),
  postUserRoleForm: config => createAPI('/api/role/form', 'post', config),
  postUserRoleMenu: config => createAPI('/api/customer/menus', 'post', config),
  postUserRoleSave: config => createAPI('/api/role/save', 'post', config),
  getRoleMenus: config => createAPI('/api/role/menus', 'post', config),
  getRoleMenusOperations: config => createAPI('/api/role/menu/operations', 'post', config),
  // 分类管理
  getCategories: config => createAPI('/mbd-dp-manager/cat/categories', 'post', config), // 数据中台-获取分类列表树
  getCategoriesDetail: config => createAPI('/mbd-dp-manager/cat/detail', 'post', config), // 数据中台-类别详情
  getCategoriesDetailWithoutLoading: config => createAPI('/mbd-dp-manager/cat/detail', 'post', config, {
    neverLoading: true
  }),
  // 数据中台-类别详情
  getCategoriesSave: config => createAPI('/mbd-dp-manager/cat/save', 'post', config), // 数据中台-保存分类
  getCategoriesDelete: config => createAPI('/mbd-dp-manager/cat/delete', 'post', config), // 数据中台-删除分类
  getCategoriesOrder: config => createAPI('/mbd-dp-manager/cat/order', 'post', config), // 数据中台-分类排序
  getCategoriesDepartment: config => createAPI('/mbd-dp-manager/cat/department', 'post', config), // 数据中台-分类排序
  // 分类子树
  postCatCategory: config => createAPI('/mbd-dp-manager/cat/category', 'post', config),
  // 机构子树
  postCatDepartment: config => createAPI('/mbd-dp-manager/cat/department', 'post', config),
  // 主题子树
  postCatTheme: config => createAPI('/mbd-dp-manager/cat/theme', 'post', config),
  // 用户管理
  postUserList: config => createAPI('/api/user/search', 'post', config), // 开放接口v3-获取用户列表数据
  postUserCusRoleSearch: config =>
    createAPI('/api/user/customerRoleSearch', 'post', config), // 开放接口v3-获取用户角色信息
  postUserDelete: config => createAPI('/api/user/delete', 'post', config), // 开放接口v3-删除用户信息
  postUserImport: config => createAPI('/api/user/import', 'post', config), // 开放接口v3-用户导入
  postUserSave: config => createAPI('/api/user/save', 'post', config), // 开放接口v3-保存用户信息
  postTrackHomeSubscribes: config =>
    createAPI('/api/user/setting/track_home_subscribes', 'post', config), // 开放接口v3-获取用户自定义重点栏目
  postTrackHomeSubscribesNoLoading: config =>
    createAPI('/api/user/setting/track_home_subscribes', 'post', config, {
      neverLoading: true
    }),
  postTrackHomeSubscribesuUpsert: config =>
    createAPI(
      '/api/user/setting/track_home_subscribes/upsert',
      'post',
      config,
      {
        neverLoading: true
      }
    ), // 开放接口v3-新增(更新) 用户自定义重点栏目
  uploadImage: config => createAPI('/api/upload', 'post', config), // 上传图片
  deleteImage: config => createAPI('/api/delete/file', 'post', config), // 上传图片
  // 部门管理（机构管理）
  getDepartmentList: config => createAPI('/api/department/tree', 'post', config, {}), // 部门列表
  getDepartmentDetail: config => createAPI('/api/department/get', 'post', config, {}), // 部门详情
  getRoles: config => createAPI('/api/mam/getRoles', 'post', config, {}), // 查询媒资角色
  getConfigUrl: config => createAPI('/api/mam/getMamAuthUrl', 'post', config), // 获取跳转媒资库权限管理地址
  getVideoAudio: config => createAPI('/api/media/getMamConfig', 'post', config), // 获取跳转媒资库权限管理地址
  configVideoAudio: config => createAPI('/api/media/saveMamConfig', 'post', config), // 获取跳转媒资库权限管理地址
  saveDepartment: config => createAPI('/api/department/save', 'post', config, {}), // 部门修改
  deleteDepartment: config => createAPI('/api/department/delete', 'post', config, {}), // 部门删除
  orderDepartment: config => createAPI('/api/department/order', 'post', config, {}), // 部门拖动
  getNationDetail: config => createAPI('/mbd-dp-manager/cat/nation', 'post', config, {}), // 查询民族
  // 系统参数
  getParamsGroup: config => createAPI('/mbd-dp-manager/param/group/list', 'post', config, {}), // 获取系统参数分组列表
  getParamsList: config => createAPI('/mbd-dp-manager/param/list', 'post', config, {}), // 获取系统参数列表
  saveParams: config => createAPI('/mbd-dp-manager/param/save', 'post', config, {}), // 新增系统参数
  deleteParams: config => createAPI('/mbd-dp-manager/param/delete', 'post', config, {}) // 删除系统参数
}
